module.exports = __webpack_public_path__ + "img/user-card.2bac9627.png";